import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, DISPOSAL_ACCOUNT, GENERAL_ACCOUNT, GET_ALL_PRODUCT_URL, LFH_HOME, PAGE_SIZE, PL_ACCOUNT, SAMPLING_ACCOUNT} from '../../common/constants';
import { formatTo0Decimal, isEmptyArray, isNotEmpty } from '../../common/util.services';
import { getInputCodeValues, searchStockList, transferStock } from '../order.services';
import {getAllSuppliers} from '../../supplier/supplier.services';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import { Grid, IconButton, Menu, MenuItem, Stack, Tooltip } from '@mui/material';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import ICheckbox from '../../../components/checkbox/i-checkbox.component';
import { getMasterDataByCodeAndSupplier, getMasterDataById } from '../../master-data/masterdata.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';
import ProductDetailComponent from '../../enquiry/enq-product/product-detail.component';
import { getEnquiryProduct } from '../../enquiry/enquiry.services';
import { HelpOutline, ListAltOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InputFormComponent from './input-form.component';

const StockList = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [stockData, setStockData] = useState(rows);
  const [searchData, setSearchData] = useState<any>({location: ALL, product: ALL, size: null, color: null, 
                                                     sku: null, pack: null, stockDate: dayjs()});
  const [material, setMaterial] = useState(0);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [inProgress, setInProgress] = useState(0);
  const [finishedGood, setFinishedGood] = useState(0);
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [openInputForm, setOpenInputForm] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const [totalStock, setTotalStock] = useState(0);
  const [locationList, setLocationList] = useState<any>([]);
  const [inputCodeValues, setInputCodeValues] = useState<any>([]);
  const [showSyncMsg, setShowSyncMsg] = useState(false);
  const navigate = useNavigate();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [activeRow, setActiveRow] = useState<any>(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const [rowData, setRowData] = useState<any>([]);
  const [message, setMessage] = useState('');
  const [actionType, setActionType] = useState('');
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columns: GridColDef[] = [
    { field: 'inputCode', headerName: 'Item Code', filterable: false, sortable: false, editable: false, width: 90,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => {openSpecsPopup(params.row.inputId)}}>{params.row.inputCode}</div> }
    },
    { field: 'inputDesc', headerName: 'Item Desc', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'orderCode', headerName: 'Order Code', filterable: false, sortable: false, editable: false, width: 125 },
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 125 },
    { field: 'prdDesc', headerName: 'Product Desc', filterable: false, sortable: false, editable: false, width: 200,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params.row.productId)}
                                  sx={{ p: 0.6, ml: -1 }}> <HelpOutline fontSize="small" color='secondary'/>
                                </IconButton>{params.row.prdDesc}</Stack>)
    },
    { field: 'location', headerName: 'Location', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'quantity', headerName: 'Quantity', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params) => formatTo0Decimal(params.row.quantity) + ' ' + params.row.inputUom,
      cellClassName: (params) => { return params.row.quantity < 0 ? 'AdDiffN' : '' }
    },
    { field: 'materialCost', headerName: 'Value', filterable: false, sortable: false, editable: false, width: 110,
      valueFormatter: (materialCost: any) => '₹ ' + formatTo0Decimal(materialCost)
    },
    { field: 'stockType', headerName: 'Stock Type', filterable: false, sortable: false, editable: false, width: 135 },
    { field: 'nextProcess', headerName: 'Next Proc', filterable: false, sortable: false, editable: false, width: 90 },
    { field: 'action', headerName: 'Action', filterable: false, sortable: false, editable: false, width: 75,
      renderCell: (params: any) => (<Stack direction="row" spacing={-1} alignItems="center"
                                      justifyContent="center" sx={{ width: '100%', height: '100%' }}>
                                      <Tooltip title={'Go to ledger'} PopperProps={popperProps}>
                                        <IconButton onClick={() => ledger(params.row)} size="small" >
                                          <ListAltOutlined fontSize='small' color='secondary'/> </IconButton>
                                      </Tooltip>
                                      <Tooltip title={'Transfer stock'} PopperProps={popperProps}>
                                        <IconButton onClick={(e) => handleMenuOpen(e, params.row)} size="small" >
                                          <MoreVertIcon fontSize='small' color='secondary'/> </IconButton>
                                      </Tooltip>
                                    </Stack>)
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getAllSuppliers(appContext,
      (response: any) => {
        let location = [DISPOSAL_ACCOUNT, GENERAL_ACCOUNT, SAMPLING_ACCOUNT, PL_ACCOUNT, ...response.data];
        setLocationList(location);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  },[])

  useEffect(() => {
    if (isEmptyArray(rows)) {
      searchStockList(searchData, page, pageSize, appContext,
        (response: any) => {
          setStockData(response.data.data[0]);
          setTotalRows(response.data.totalElements);
          setTotalStock(response.data.data[1]);
          setMaterial(response.data.data[2]);
          setInProgress(response.data.data[3]);
          setFinishedGood(response.data.data[4]);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchData, page, pageSize]);

  const search = (data: any) => {
    setSearchData(data);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const ledger = (row: any) => {
    navigate('/stock/ledger', {state: {orderCode: row.orderCode, inputCode: row.inputCode, location: row.location}});
  }

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const disposalAccount = (row: any) => {
    setActionType('Disposal');
    setRowData(row);
    setMessage('Do you want to transfer the stock to disposal account?');
    setShowSyncMsg(true);
  }
  
  const processLossAccount = (row: any) => {
    setActionType('Process Loss');
    setRowData(row);
    setMessage('Do you want to transfer the stock to process loss account?');
    setShowSyncMsg(true);
  }

  const generalAccount = (row: any) => {
    setActionType('General Account');
    setRowData(row);
    setMessage('Do you want to transfer the stock to general account?');
    setShowSyncMsg(true);
  }

  const samplingAccount = (row: any) => {
    setActionType('Sampling Account');
    setRowData(row);
    setMessage('Do you want to transfer the stock to sampling account?');
    setShowSyncMsg(true);
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const closeInputForm = (data: any) => {
    if(isNotEmpty(data)) {
      if('Other' === data.inputCode) {
        getMasterDataByCodeAndSupplier(data.otherCode, LFH_HOME, appContext,
          (response: any) => {
            if(isNotEmpty(response.data)) {
              rowData.genAcctInputCode = data.inputCode;
              rowData.otherCode = data.otherCode;
              transferStockData();
              appContext.setShowLoader(false);
              setLoading(false);
              setOpenInputForm(false);
            } else {
              appContext.setDialogMessage('No master data found for LFH Home as supplier.');
            }
          }, (error: any) => {
            appContext.setShowLoader(false);
            appContext.setErrorMessage(error.message);
            setLoading(false);
          });
      } else {
        setOpenInputForm(false);
        rowData.genAcctInputCode = data.inputCode;
        rowData.otherCode = data.otherCode;
        transferStockData();
      }
    } else {
      setOpenInputForm(false);
    }
  }

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, rowData: any) => {
    setMenuAnchorEl(event.currentTarget);
    setActiveRow(rowData);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setActiveRow(null);
  };

  function isMenuApplicable(row: any, type: any) {
    let stockDate = dayjs(dayjs(searchData.stockDate).format('YYYY-MM-DD'));
    let today = dayjs(dayjs().format('YYYY-MM-DD'));
    if(stockDate.isBefore(today)) {
      return false;
    }

    if(isNotEmpty(row)) {
      if(row.quantity <= 0) {
        return false;
      }

      if('Disposal' === type || 'General Account' === type || 'Sampling Account' === type) {
        if(row.location !== LFH_HOME) {
          return false;
        }
      } else if('Process Loss' === type) {
        if('NA' === row.nextProcess || 'Work In Progress' !== row.stockType) {
          return false;
        }
      }
    }

    return true;
  }

  function transferStockData() {
    rowData.transferType = actionType;
    appContext.setShowLoader(true);
    setLoading(true);
    transferStock(rowData, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        navigate(0);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });   
  }
  
  const onOkClick = () => {
    if('General Account' !== actionType) {
      transferStockData();
    } else {
      getInputCodeValues(rowData, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        let inputValue = ['Finished Product', 'Other', ...response.data];
        setInputCodeValues(inputValue);
        setOpenInputForm(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
    }
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const openSpecsPopup = (inputId: any) => {
    setLoading(true);
    getMasterDataById(inputId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        response.data.desc = 'NA';
        response.data.supplier = 'NA';
        response.data.unitCost = 'NA';
        response.data.sku = 'NA';
        response.data.remarks = 'NA';
        setSpecsData(response.data);
        setOpenSpecs(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  };

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1} alignItems="center">
        <Grid xs={1.5}>
          <IDateField name='stockDate' label='Stock Date' />
        </Grid>
        <Grid xs={1.5}>
          <ITextField name='searchText' label='Product Description' />
        </Grid>
        <Grid xs={1.5}>
          <ITextField name='orderCode' label='Order Code' />
        </Grid>
        <Grid xs={1.5}>
          <ITextField name='itemCode' label='Item Code' />
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='location' label='Location' itemList={locationList} allItemRequired={true} />
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='product' label='Product' url={GET_ALL_PRODUCT_URL} allItemRequired={true}/>
        </Grid>
        <Grid xs={1}>
          <ITextField name='sku' label='SKU' />
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='includeSale' label='Sale' defaultChecked={false}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='zeroStock' label='0 Stock' defaultChecked={false}/>
        </Grid>
      </Grid>
      </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <Grid container spacing={2}>
        <Grid xs={12}>
          <IGridComponent title={''} rows={stockData} columns={columns} loading={loading} maxHeight={390} showExtraText
            paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows} disableRowSelectionOnClick={true}
            showAddBtn={false} showAction={false} getRowId={(row: any) => row.id} />
            <Menu anchorEl={menuAnchorEl} open={isMenuOpen} onClose={handleMenuClose} 
              anchorOrigin={{vertical: 'top', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'right'}}>
              <MenuItem disabled={!isMenuApplicable(activeRow, 'General Account')} 
                onClick={() => { generalAccount(activeRow); handleMenuClose(); }}>General Account</MenuItem>
              <MenuItem disabled={!isMenuApplicable(activeRow, 'Sampling Account')}
                onClick={() => { samplingAccount(activeRow); handleMenuClose(); }}>Sampling Account</MenuItem>
              <MenuItem disabled={!isMenuApplicable(activeRow, 'Disposal')}
                onClick={() => { disposalAccount(activeRow); handleMenuClose(); }}>Disposal</MenuItem>
              <MenuItem disabled={!isMenuApplicable(activeRow, 'Process Loss')}
                onClick={() => { processLossAccount(activeRow); handleMenuClose(); }}>Process Loss</MenuItem>
            </Menu>
            <YesNoDialog open={showSyncMsg} onClose={() => { setShowSyncMsg(false) }}
              onOk={() => { setShowSyncMsg(false); onOkClick(); }} isHorizontal={true} 
              message={message}/>
        </Grid>
        <Grid xs={12} display="flex" justifyContent="center">
          <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1200px', border: '1px solid #D3D3D3', borderRadius: '4px'}}>
            <Grid xs={3}>
              <IReadOnlyField value={'₹ ' + formatTo0Decimal(material)} label='Raw Material' />
            </Grid>
            <Grid xs={3}>
              <IReadOnlyField value={'₹ ' + formatTo0Decimal(inProgress)} label='Work In Progress' />
            </Grid>
            <Grid xs={3}>
              <IReadOnlyField value={'₹ ' + formatTo0Decimal(finishedGood)} label='Finished Goods' />
            </Grid>
            <Grid xs={3}>
              <IReadOnlyField value={'₹ ' + formatTo0Decimal(totalStock)} label='Total Stock' />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
      <IDialogComponent onClose={closeInputForm} open={openInputForm} title={'Select Input Code'}
        dialogBody={<InputFormComponent inputCodeValues={inputCodeValues} close={closeInputForm}/>} />
    </>
  }

  return <TitlePanel title='Stock List' panelBody={getMainPanel()} />
}

export default StockList;